import React, { useContext, useEffect, useState } from 'react';
import { Link, useLoaderData } from 'react-router-dom';

import {
  SlBreadcrumb,
  SlBreadcrumbItem,
} from '@shoelace-style/shoelace/dist/react';
import AllClaimsComponent from '../components/all-claims.component';
import { Trans, useTranslation } from 'react-i18next';
import Button from '../components/button.component';
import AppContext from '../data/AppContext';
import { CardStyles } from '../components/card.styles';

const SingleMountain = () => {
  const { t } = useTranslation('app');
  const mountain = useLoaderData();
  const [hasClaims, setHasClaims] = useState(false);

  const { claimedMountainIds } = useContext(AppContext);

  useEffect(() => {
    if (!!claimedMountainIds.length) {
      setHasClaims(claimedMountainIds.includes(mountain.id));
    }
  }, [claimedMountainIds, mountain.id]);

  return (
    <div>
      <SlBreadcrumb>
        <span slot="separator">/</span>
        <SlBreadcrumbItem>
          <Link to={'/'} style={{ color: 'inherit', textDecoration: 'none' }}>
            {t('common.all')}
          </Link>
        </SlBreadcrumbItem>
        <SlBreadcrumbItem>{mountain.name}</SlBreadcrumbItem>
      </SlBreadcrumb>
      <h1>{mountain.name}</h1>
      {hasClaims ? (
        <CardStyles style={{ margin: '-1rem 0 2rem' }}>
          <div style={{ marginBottom: '1rem' }}>
            <Trans
              t={t}
              i18nKey="mountain.needsMoreVoices"
              values={{ name: mountain.name }}
            />
          </div>
          <Link to={'add'}>
            <Button>{t('mountain.newVoice')}</Button>
          </Link>
        </CardStyles>
      ) : (
        <CardStyles style={{ margin: '-1rem 0 2rem' }}>
          <div style={{ marginBottom: '1rem' }}>
            <Trans
              t={t}
              i18nKey="mountain.needsVoice"
              values={{ name: mountain.name }}
            />
          </div>
          <Link to={'add'}>
            <Button>{t('mountain.newVoice')}</Button>
          </Link>
        </CardStyles>
      )}

      <AllClaimsComponent mountainId={mountain.id} showFirst={true} />
    </div>
  );
};

export default SingleMountain;
